// External libraries
import { useState } from 'react'
// Components
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogTrigger,
} from '@/components/ui/dialog'
import { buttonVariants } from '@/components/ui/button'
import { PlusCircleIcon } from 'lucide-react'

import ManageDocumentsForm from '@/components/ManageDocuments/NewDocumentForm'

export default function NewDocumentDialog() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger className={`${buttonVariants({ size: 'sm' })} ml-auto h-8 lg:flex`}>
        <PlusCircleIcon className="mr-2 h-4 w-4" />
        Add Documents
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="pb-4">Add New Documents</DialogTitle>
          {/* <DialogDescription></DialogDescription> */}
        </DialogHeader>
        <section>
          <ManageDocumentsForm closeDialog={() => setIsOpen(false)} />
        </section>
        <DialogDescription className="sr-only">
          Form to upload new documents to the system. Complete all required fields and submit to add documents.
        </DialogDescription>
      </DialogContent>
    </Dialog>
  )
}
